module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-11.365f374b.png";